<h2 mat-dialog-title class="statistics-title">
  Statistik – {{ data.event?.name || 'Event' }}
</h2>
<div class="statistics-title-divider"></div>

<mat-dialog-content class="statistics-content">
  <!-- Loading -->
  <div *ngIf="isLoading" class="statistics-loading">
    <mat-icon class="statistics-spinner">hourglass_empty</mat-icon>
    <span>Lade Teilnehmer...</span>
  </div>

  <!-- Empty state -->
  <p *ngIf="!isLoading && participants.length === 0" class="statistics-empty">
    Keine Anmeldungen vorhanden.
  </p>

  <!-- Participant list -->
  <div class="statistics-list" *ngIf="!isLoading && participants.length > 0">
    <mat-card
      class="statistics-card"
      *ngFor="let participant of participants"
      [class.statistics-card-absent]="!participant.attending">
      <mat-icon class="statistics-avatar" [class.avatar-attending]="participant.attending" [class.avatar-absent]="!participant.attending">
        {{ participant.attending ? 'check_circle' : 'cancel' }}
      </mat-icon>
      <div class="statistics-details">
        <div class="statistics-name">{{ getParticipantName(participant) }}</div>
        <div class="statistics-status" [class.status-attending]="participant.attending" [class.status-absent]="!participant.attending">
          {{ participant.attending ? 'Angemeldet' : 'Abgemeldet' }}
        </div>
        <div class="statistics-date" *ngIf="getRegistrationDate(participant)">
          Angemeldet am: {{ getRegistrationDate(participant) }}
        </div>
        <div class="statistics-excuse" *ngIf="!participant.attending && participant.excuseText">
          {{ participant.excuseText }}
        </div>
      </div>
    </mat-card>
  </div>

  <!-- Summary -->
  <div class="statistics-summary" *ngIf="!isLoading && participants.length > 0">
    <div class="statistics-summary-divider"></div>
    <div class="statistics-summary-row">
      <div class="summary-item summary-total">
        <mat-icon class="summary-icon">group</mat-icon>
        <span>Anmeldungen gesamt: <strong>{{ totalCount }}</strong></span>
      </div>
      <div class="summary-item summary-attended">
        <mat-icon class="summary-icon icon-attended">check_circle</mat-icon>
        <span>Angemeldet: <strong>{{ attendedCount }}</strong></span>
      </div>
      <div class="summary-item summary-absent">
        <mat-icon class="summary-icon icon-absent">cancel</mat-icon>
        <span>Abgemeldet: <strong>{{ notAttendedCount }}</strong></span>
      </div>
    </div>
  </div>
</mat-dialog-content>

<div class="statistics-bottom-divider"></div>

<mat-dialog-actions class="statistics-actions">
  <button
    mat-stroked-button
    class="statistics-btn close-btn"
    (click)="onClose()">
    <mat-icon>close</mat-icon>
    <span>Schließen</span>
  </button>
</mat-dialog-actions>
